const groupChecklists = [
    {
        "category": "01",
        "text": "1.條件",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "01-1",
                "text": "1.1 設有管理中心負責業務規劃及執行?"
            },
            {
                "code": "01-2",
                "text": "1.2 集團成員及作業方法採行管理中心建立之品質管理系統，且持續接受管理中心之監督，並符合其規範及要求。產製之有機農產品及有機轉型期農產品以集團名義標示銷售?"
            }
        ]
    },
    {
        "category": "02",
        "text": "2.文件要求",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "02-1",
                "text": "2.1 具有所有成員與管理中心有契約或其他法律關係之證明文件(生產者同意書註明管理系統對生產者的責任、內部管理制度的規章、生產者同意遵守農委會及慈心相關法規並配合內、外部查驗)?"
            },
            {
                "code": "02-2",
                "text": "2.2 每個生產者已簽署生產者同意書?"
            },
            {
                "code": "02-3",
                "text": "2.3 具有管理中心品質管理系統文件、相關作業程序及執行記錄，如組織架構、職掌、規定及內部成員違規處置等是否明確敘述？"
            },
            {
                "code": "02-4",
                "text": "2.4 管理中心是否每年至少有一次自我查核紀錄?"
            },
            {
                "code": "02-5",
                "text": "2.5 管理中心是否每年有對所有成員至少一次之內部稽核紀錄?"
            },
            {
                "code": "02-6",
                "text": "2.6 是否提供生產場區之位置圖及每一田區之農場圖?"
            },
            {
                "code": "02-7",
                "text": "2.7 是否提供作物、成品、半成品倉庫、加工場所及相關設備的分布圖?"
            },
        ]
    },
    {
        "category": "03",
        "text": "3.教育訓練",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "03-1",
                "text": "3.1 教育訓練紀錄，含取得資格的訓練及每年必要的講習？(說明對象)?"
            }
        ]
    },
    {
        "category": "04",
        "text": "4.各項程序及作業說明",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "04-1",
                "text": "4.1 是否具各項操作過程及作業說明？"
            }
        ]
    },
    {
        "category": "05",
        "text": "5.文件管制",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "05-1",
                "text": "5.1 是否保存設備檢查紀錄？"
            },
            {
                "code": "05-2",
                "text": "5.2 確保在使用時文件的有效版本，所有文件增定變更\n" +
                    "時，是否主動通知本公司，尤其生產者名單及農地\n" +
                    "資訊，必須隨時保持最新版本備查？"
            }
        ]
    },
    {
        "category": "06",
        "text": "6.內部稽核",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "06-1",
                "text": "6.1 內部檢查員是否排除檢查自己及同一住戶、親屬或小組內人員的生產田區？"
            },
            {
                "code": "06-2",
                "text": "6.2 內部稽核查驗紀錄，內容含有機、轉型面積，每一塊土地的預估與實際產量，作物生長狀況及投入資材等？"
            },
            {
                "code": "06-3",
                "text": "6.3 產銷班的內部稽核是否有矯正措施？"
            },
            {
                "code": "06-4",
                "text": "6.4 矯正措施的要求與執行是否有效落實？"
            }
        ]
    },
    {
        "category": "07",
        "text": "7.採購和追蹤體系",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "07-1",
                "text": "7.1 過磅單與田區採收量是否合理？"
            },
            {
                "code": "07-2",
                "text": "7.2 由田區作業、一次加工、貯藏、出入庫、銷售等可建立完整的追蹤體系？"
            },
            {
                "code": "07-3",
                "text": "7.3 保存能追溯實際生產全程的詳細紀錄(如：生產場區圖、農場工作紀錄、一次加工、貯藏、出入庫、銷售等紀錄)？"
            }
        ]
    },
    {
        "category": "08",
        "text": "8.持續改進",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "08-1",
                "text": "8.1 是否建立改正和預防措施，以消除不符合或潛在不符合因素？"
            },
            {
                "code": "08-2",
                "text": "8.2 不符合發生時，是否確定不符合的原因？"
            },
            {
                "code": "08-3",
                "text": "8.3 不符合發生時，是否評估確保不符合因素不再發生的措施？"
            },
            {
                "code": "08-4",
                "text": "8.4 是否記錄所採取改正措施的結果？"
            },
            {
                "code": "08-5",
                "text": "8.5 是否評估所採取的改正或預防措施有效？"
            }
        ]
    },
]

export default groupChecklists;